module.exports = __webpack_public_path__ + "img/fill_black_home.cf24e7c0.svg";